// src/store/media/progress.slice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProgressState {
  percent: number;
  visible: boolean;
}

const initialState: ProgressState = {
  percent: 0,
  visible: false
};

const progressSlice = createSlice({
  name: 'progress',
  initialState,
  reducers: {
    updateProgress: (state, action: PayloadAction<number>) => {
      state.percent = action.payload;
    },
    showProgress: (state) => {
      state.visible = true;
    },
    hideProgress: (state) => {
      state.percent = 0;
      state.visible = false;
    }
  }
});

export const { updateProgress, showProgress, hideProgress } = progressSlice.actions;
export default progressSlice.reducer;
